import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { BaseService } from "./base.service";
import { LatestUpdate } from "../models/latestupdate";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { AuthService } from "./auth.service";

@Injectable()
export class LatestUpdateService extends BaseService {
    constructor(http: HttpClient,
        private applicationSettings: ApplicationSettingsService,
        authService: AuthService,
        toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

      /**
       * Get latest updates for the given page number and page size
       * @param pagenumber
       * @param pagesize
       */
    getUpdates(pageNumber: number, pageSize: number): Observable<LatestUpdate[]> {
        return super.get(`${this.applicationSettings.apiUrl}LatestUpdate/${pageNumber}/${pageSize}`);
    }

    /**
     * Get latest updates count
     */
    getTotalUpdates(): Observable<number> {
        return super.get(`${this.applicationSettings.apiUrl}LatestUpdate/`);
    }
}